/* src/app/core/authentication/forgot/forgot.component.scss */
.background {
  position: relative;
  min-height: 100vh;
  font-family: "Inter Tight", sans-serif;
  background:
    linear-gradient(
      135deg,
      #e3fd64 50%,
      #1e2235 50%);
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.logo-container {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.logo {
  height: 50px;
  filter: drop-shadow(0 0 15px rgba(0, 0, 0, 0.7)) drop-shadow(0 0 25px rgba(0, 0, 0, 0.5));
}
.login-box {
  background: rgba(255, 255, 255, 0.97);
  width: 100%;
  max-width: 400px;
  margin-top: 20px;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  text-align: center;
}
.login-box h4 {
  margin-bottom: 10px;
  font-weight: 600;
  color: var(--cf-brand-dark);
}
.subtitle {
  font-size: 14px;
  color: var(--cf-text-muted);
  margin-bottom: 20px;
}
.mat-form-field {
  width: 100%;
  margin-bottom: 15px;
}
.iconoLogin {
  color: var(--cf-brand-dark);
  font-size: 20px;
}
.buttons {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.btn {
  width: 100%;
  padding: 12px 0;
  border-radius: 10px;
  background: var(--cf-brand);
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 14px;
  font-family: "Inter Tight", sans-serif;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease;
}
.btn:hover {
  background: var(--cf-brand-dark);
}
.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.goLogin {
  font-size: 13px;
  color: var(--cf-text-muted);
  cursor: pointer;
  text-decoration: underline;
}
.goLogin:hover {
  color: var(--cf-brand-dark);
}
/*# sourceMappingURL=forgot.component.css.map */
